<template>
  <div class="content">
    <div class="row align-items-center mb-2">
      <div class="col-md-2 ms-3" align="left">
        <v-btn fab dark x-small color="primary">
          <router-link :to="`/cliente/${cliente_id}/cuentas`">
            <v-icon dark> arrow_back</v-icon>
          </router-link>
        </v-btn>
      </div>
    </div>

    <LayoutPage :title="'Ajustes'">
      <v-app>
        <v-main>
          <section v-if="errored">
            <v-alert
              border="left"
              class="mt-4 mx-3 elevation-3"
              color="red lighten-2"
              dark
            >
              Lo sentimos, no es posible obtener la información en este momento,
              por favor intente nuevamente mas tarde.
            </v-alert>
          </section>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="itemAjustes"
            :loading="cargando"
            :items-per-page="itemsPerPage"
            hide-default-footer
            disable-sort
            loading-text="Cargando... Espere por favor"
            no-results-text="No se encontraron registros"
            no-data-text="No se encontraron registros"
            class="elevation-1 trow"
          >
            <template v-slot:no-results>
              <v-alert color="error" icon="warning">
                found no results.
              </v-alert>
            </template>
            <!-- Monto -->
            <template v-slot:[`item.amount`]="{ item }">
                {{formatCurrency(item.amount) }}
            </template>
              <template v-slot:[`item.applied_at`]="{ item }">
                {{item.applied_at ? formatDate(item.applied_at) :'-' }}
            </template>
            <template v-slot:footer>
              <v-row class="no-gutters mt-2 mx-2">
                <v-flex xs12 class="align-items-center">
                  <span>Mostrar</span>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn dark text color="primary" class="ml-2" v-on="on">
                        {{ rowsPerPage }}
                        <v-icon>arrow_drop_down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(number, index) in rowsPerPageArray"
                        :key="index"
                        @click="updateRowsPerPage(number)"
                      >
                        <v-list-item-title>{{ number }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-row>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-model="pagination.page"
              :length="pagination.total"
              :total-visible="pagination.visible"
              @input="onPageChange"
            ></v-pagination>
          </div>
        </v-main>
      </v-app>
    </LayoutPage>
  </div>
</template>

<script>
import LayoutPage from "../../../LayoutPage.vue";
import moment from "moment";
import { Cuentas } from "../../../../services/cuentas";
import formatDate from "../../../../utils/formatDate";
import { formatCurrency } from "../../../../utils/formatImport";


export default {
  components: {
    name: "Ajustes",
    LayoutPage,
  },
  data: function() {
    return {
      cliente_id: this.$route.params.cliente_id,
      cuentas_id: this.$route.params.cuenta_id,
      createCuenta: false,
      
      errored: false,
      menu: false,
      menu2: false,
      formatDate,
     itemAjustes: [],
     
      // page: 1,
      search: "",
      valid: false,
    
        headers: [
        { text: "Referencia Pago", value: "referencia_pago", sortable: false },
        { text: "Operación", value: "adjustment_type.operation" },
        { text: "Estado", value: "status", sortable: false },
        { text: "Importe", value: "amount", sortable: false },
        { text: "Razón", value: "reason", sortable: false },
        { text: "Movimiento", value: "movimiento.id", sortable: false },
        { text: "Fecha", value: "applied_at", sortable: false,align: "center" },
      ],
      
      itemsPerPage: 10,
      pageCount: 0,
      // paginacion api
      pagination: {
        page: 1,
        total: 0,
        visible: 7,
      },
      //  numero de registros por pagina - Permisos.vue
      rowsPerPageArray: [10, 20, 30],
      rowsPerPage: 10,
      cargando: false,
     formatCurrency,
     
    };
  },
  created() {
    this.getDatos();
    },
    
  methods: {
    onPageChange() {
      this.getDatos();
    },
   
    updateRowsPerPage(number) {
      this.rowsPerPage = number;
      this.getDatos(number);
    },
    toast(name, msg, type, color) {
      this.$toastr.Add({
        name: name,
        title: "",
        msg: msg,
        clickClose: true,
        type: type,
        preventDuplicates: true,
        style: {
          color: "white",
          backgroundColor: color,
          width: "300px",
        },
      });
    },
    
    getDatos: function() {
        this.cargando = true;
      const params = {
        Number: this.pagination.page,
        Size: this.rowsPerPage,
        CuentaID: this.cuentas_id,
      };
      Cuentas.ajustes(params)
          .then((response) => {
          if (!response.data.data.adjustments) {
            this.itemAjustes = [];
            this.pagination.page = 1;
            this.pagination.total = 0;
          } else {
            this.itemAjustes = response.data?.data?.adjustments;
            this.pagination.page = response.data?.data?.meta?.page?.currentPage;
            this.pagination.total = response.data?.data?.meta?.page?.lastPage;
          }
        })
        .catch(() => {
          // console.error("Error al consultar puntos de venta: ", error);
          this.errored = true;
        })
        .finally(() => {
          this.cargando = false;
        });
    },
   
  },
};
</script>
<style scoped>
a[data-v-1b84c964] {
  color: #e6f1e3;
}

.theme--light.v-btn {
  color: rgb(93 175 118 / 87%);
}

.theme--dark.v-btn.v-btn--has-bg {
  background-color: #50b565;
}
.v-dialog > .v-card > .v-card__text {
  padding-bottom: 0px;
}
</style>
